import { supabase } from '@/integrations/supabase/client';
import {
  createQuittanceForPeriod as createQuittanceCore,
  type QuittanceLease,
  type CreateQuittanceResult,
} from '../../supabase/functions/_shared/quittance-core.ts';

export type { QuittanceLease, CreateQuittanceResult };

export function createQuittanceForPeriod(
  lease: QuittanceLease,
  period: string, // 'YYYY-MM'
  paymentDate: string, // 'YYYY-MM-DD'
  method: string,
): Promise<CreateQuittanceResult> {
  return createQuittanceCore(supabase, lease, period, paymentDate, method);
}
